import containerFuild from '../html-snippets/container-fuild';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';
import css from '../css-snippets/section-card-banner-02-rivoneed';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';

const dividerPrimaryHtml = dividerPrimary({
  show: true,
  maxWidth: 48,
  height: 4,
  backgroundColor: '#ffffff4d',
  align: 'left',
});
const buttonRivoneedHtml = buttonPrimaryHtml({
  show: false,
  backgroundColor: '#ff0000',
  color: '#FFFFFF',
  radius: 4,
  text: 'Buy Now',
  link: '#',
  iconPrefix: {
    show: false,
    src: '',
  },
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
  subBtn: {
    show: false,
    text: '',
  },
});

const html = `
<div class="container">
  <div class="wrap-card">
    <div data-attribute="wrap-banner" data-use-banner-mobile="true" class="wrap-banner">
      <img
        data-attribute="banner-desktop-img"
        class="banner-desktop"
        src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cde2827f2ee3ec34bb7ea.png"
        alt=""
      />
      <img
        data-attribute="banner-mobile-img"
        class="banner-mobile"
        src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cde4111f67ec93cebff27.png"
        alt=""
      />
      <div data-width-content="625" data-attribute="wrap-content" class="wrap-content" style="--width-content: 625px">
        <div data-attribute="heading-content" data-show="true" class="heading-content">
          <h2>Evaluated by Professional Technicians</h2>
          <p>Designed and tested to meet everyday repair needs.</p>
        </div>
        <div data-attribute="divider-content" data-show="true" class="divider-content">${dividerPrimaryHtml}</div>
        <div data-attribute="description-content" data-show="true" class="description-content">
          <p>
            "This magnetic light bar solves the core problem of handheld flashlights—hands-free, stable light is what
            makes repairs actually efficient."
          </p>
          <p>&nbsp;</p>
          <p>- David Torres, ASE-Certified Automotive Technician</p>
        </div>
        <div data-attribute="wrap-image-small" data-show="true" class="wrap-image-small">
          <img
            data-attribute="image-small"
            src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cffc9c5e4f05cbd90d10f.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
  ${buttonRivoneedHtml}
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#1a1a1a',
  textColor: '#ffffff',
});
